
































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { fileUpload } from "@/constants";
import { SupportAdvertisements } from "@/http/api/v2/supporter/advertisements";
import { SupportAdvertisementClickDto, SupportAdvertisementDto, SupportAdvertisementSaveDto } from "@/http/dto/supportAdvertisement";

const maxFileSize = 5 * 1024 * 1024;

@Component
export default class SupportAdvertisement extends Vue {
  area = "";
  status = "all";
  keyword = "";
  current = 1;
  total = 0;
  loading = false;
  errorMessage = "";
  data: SupportAdvertisementDto[] = [];
  summary = { active: 0, scheduled: 0, disabled: 0, ended: 0 };
  modalVisible = false;
  detailLoading = false;
  saving = false;
  deleting = false;
  uploading = false;
  form: any = this.emptyForm();
  clickVisible = false;
  clickLoading = false;
  clicks: SupportAdvertisementClickDto[] = [];
  clickCurrent = 1;
  clickTotal = 0;
  selectedAdvertisement: SupportAdvertisementDto | null = null;

  get pagination() { return { total: this.total, pageSize: 20, current: this.current, showTotal: (total: number) => `총 ${this.number(total)}개`, showSizeChanger: false }; }
  get clickPagination() { return { total: this.clickTotal, pageSize: 20, current: this.clickCurrent, showTotal: (total: number) => `총 ${this.number(total)}회`, showSizeChanger: false }; }
  get columns() { return [
    { title: "미리보기", dataIndex: "preview", width: 120, fixed: "left", scopedSlots: { customRender: "preview" } },
    { title: "광고", dataIndex: "advertisement", width: 230, scopedSlots: { customRender: "advertisement" } },
    { title: "영역", dataIndex: "area", width: 100, scopedSlots: { customRender: "area" } },
    { title: "상태", dataIndex: "status", width: 100, scopedSlots: { customRender: "status" } },
    { title: "노출 기간", dataIndex: "period", width: 200, scopedSlots: { customRender: "period" } },
    { title: "클릭", dataIndex: "clicks", width: 130, scopedSlots: { customRender: "clicks" } },
    { title: "최근 수정", dataIndex: "updatedTime", width: 150, scopedSlots: { customRender: "updated" } },
    { title: "관리", dataIndex: "actions", width: 90, fixed: "right", scopedSlots: { customRender: "actions" } },
  ]; }
  clickColumns = [
    { title: "호텔", dataIndex: "hotelName", width: 150 },
    { title: "사용자", dataIndex: "userName", width: 120 },
    { title: "클릭 시각", dataIndex: "createdTime", width: 150, scopedSlots: { customRender: "clickDate" } },
  ];

  mounted() { this.load(); }
  emptyForm() { return { objectId: "", name: "", originalName: "", fileUrl: "", linkUrl: "", area: "login", isEnabled: true, startTime: null, endTime: null }; }
  number(value: number) { return Number(value || 0).toLocaleString("ko-KR"); }
  imageUrl(fileUrl: string) { if (!fileUrl) return ""; return fileUrl.startsWith("http") ? fileUrl : `https://shiftlog-test-files.s3.ap-northeast-2.amazonaws.com/${fileUrl}`; }
  dateTime(value?: string, empty = "-") { return value ? moment(value).format("YYYY.MM.DD HH:mm") : empty; }
  relativeTime(value: string) { const days = moment().diff(moment(value), "days"); return days < 1 ? "오늘" : days < 30 ? `${days}일 전` : moment(value).format("YYYY.MM.DD"); }
  areaText(value: string) { return value === "login" ? "로그인" : value === "hotel" ? "호텔 홈" : value; }
  statusText(value: string) { return ({ active: "노출 중", scheduled: "예약", disabled: "사용 중지", ended: "종료" } as any)[value] || value; }
  statusColor(value: string) { return ({ active: "green", scheduled: "blue", disabled: "default", ended: "orange" } as any)[value] || "default"; }
  errorText(error: any, fallback: string) { return (error && error.response && error.response.data && error.response.data.message) || fallback; }
  changeFilter() { this.current = 1; this.load(); }
  search() { this.current = 1; this.load(); }

  async load(pagination?: any) {
    try {
      this.loading = true; this.errorMessage = "";
      const result = await SupportAdvertisements.getAdvertisements({ page: pagination && pagination.current ? pagination.current : this.current, take: 20, area: this.area || undefined, status: this.status, keyword: this.keyword || undefined });
      this.current = result.page; this.total = result.total; this.data = result.items;
      this.summary = { active: result.activeTotal, scheduled: result.scheduledTotal, disabled: result.disabledTotal, ended: result.endedTotal };
    } catch (error) { this.errorMessage = "광고 운영 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요."; }
    finally { this.loading = false; }
  }

  openCreate() { this.form = this.emptyForm(); this.modalVisible = true; }
  async openEdit(objectId: string) {
    this.modalVisible = true; this.detailLoading = true;
    try { const detail = await SupportAdvertisements.getAdvertisement(objectId); this.form = { ...detail, startTime: detail.startTime ? moment(detail.startTime) : null, endTime: detail.endTime ? moment(detail.endTime) : null }; }
    catch (error) { this.$message.error(this.errorText(error, "광고 정보를 불러오지 못했습니다.")); this.modalVisible = false; }
    finally { this.detailLoading = false; }
  }
  closeModal() { if (this.saving || this.uploading) return; this.modalVisible = false; this.form = this.emptyForm(); }
  async uploadFile({ file, onSuccess, onError }: any) { try { onSuccess(await fileUpload(file, maxFileSize)); } catch (error) { onError(error); } }
  changeFile(event: any) {
    const { status, response, error } = event.file;
    if (status === "uploading") this.uploading = true;
    if (status === "done") { this.form = { ...this.form, fileUrl: response.url, originalName: response.fileName }; this.uploading = false; this.$message.success("이미지를 업로드했습니다."); }
    if (status === "error") { this.uploading = false; this.$message.error(error && error.message === "Large Size" ? "이미지는 5MB 이하여야 합니다." : "이미지 업로드에 실패했습니다."); }
  }
  validateForm() {
    if (!this.form.name || !this.form.name.trim()) return "광고명을 입력해주세요.";
    if (!this.form.fileUrl || !this.form.originalName) return "배너 이미지를 첨부해주세요.";
    if (this.form.linkUrl && !/^https?:\/\//i.test(this.form.linkUrl.trim())) return "연결 주소는 http:// 또는 https://로 시작해야 합니다.";
    if (this.form.startTime && this.form.endTime && !moment(this.form.endTime).isAfter(moment(this.form.startTime))) return "종료 시각은 시작 시각보다 늦어야 합니다.";
    return "";
  }
  async save() {
    const validationMessage = this.validateForm(); if (validationMessage) { this.$message.warning(validationMessage); return; }
    const saveDto: SupportAdvertisementSaveDto = { name: this.form.name.trim(), originalName: this.form.originalName, fileUrl: this.form.fileUrl, linkUrl: (this.form.linkUrl || "").trim(), area: this.form.area, isEnabled: this.form.isEnabled, startTime: this.form.startTime ? moment(this.form.startTime).toISOString() : undefined, endTime: this.form.endTime ? moment(this.form.endTime).toISOString() : undefined };
    try {
      this.saving = true;
      if (this.form.objectId) { await SupportAdvertisements.update(this.form.objectId, saveDto); this.$message.success("광고를 수정했습니다."); }
      else { await SupportAdvertisements.create(saveDto); this.$message.success("광고를 추가했습니다."); }
      this.modalVisible = false; this.form = this.emptyForm(); await this.load();
    } catch (error) { this.$message.error(this.errorText(error, "광고를 저장하지 못했습니다.")); }
    finally { this.saving = false; }
  }
  async deleteAdvertisement() {
    if (!this.form.objectId) return;
    try { this.deleting = true; await SupportAdvertisements.delete(this.form.objectId); this.modalVisible = false; this.form = this.emptyForm(); this.$message.success("광고를 삭제했습니다."); await this.load(); }
    catch (error) { this.$message.error(this.errorText(error, "광고를 삭제하지 못했습니다.")); }
    finally { this.deleting = false; }
  }
  openClicks(advertisement: SupportAdvertisementDto) { this.selectedAdvertisement = advertisement; this.clickVisible = true; this.clickCurrent = 1; this.loadClicks(); }
  async loadClicks(pagination?: any) {
    if (!this.selectedAdvertisement) return;
    try { this.clickLoading = true; const result = await SupportAdvertisements.getClicks(this.selectedAdvertisement.objectId, { page: pagination && pagination.current ? pagination.current : this.clickCurrent, take: 20 }); this.clickCurrent = result.page; this.clickTotal = result.total; this.clicks = result.items; }
    catch (error) { this.$message.error(this.errorText(error, "클릭 이력을 불러오지 못했습니다.")); }
    finally { this.clickLoading = false; }
  }
  closeClicks() { this.clickVisible = false; this.selectedAdvertisement = null; this.clicks = []; }
}
